
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDieselGeneratorAc as ObiDieselGeneratorAcElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diesel-generator-ac.js';
 
 
 

 
 export const ObiDieselGeneratorAc = createComponent({
   react: React,
   tagName: 'obi-diesel-generator-ac',
   elementClass: ObiDieselGeneratorAcElement,
   events: {
     
   }
  });
 
 